<template>
  <div class="container-fluid">
    <bnp-grid :Sortable="true" :key="tablekey" :Selectable="false" :action="true" :propsRows="Results" :propsColumn="Columns" :hasRowNum="true">
      <template slot="time" scope="props">
        {{ props.props.timeStart + ' الی ' + props.props.timeEnd }}
      </template>
      <template slot="action-slot" scope="props">
        <a @click="GetResults(props.props.id)">
          <i class="fad fa-eye text-secondary"></i>
        </a>
        &nbsp;
        <a v-if="$session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245" @click="DeleteQ(props.props.id)">
          <i class="fad fa-trash text-secondary hover-danger"></i>
        </a>
        &nbsp;
        <a v-if="$session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245" @click="Edit(props.props.id)">
          <i class="fad fa-pen text-secondary hover-warning"></i>
        </a>
      </template>
    </bnp-grid>

    <modal v-if="IfModal" @Close="CloseModal" :InheritanceTheme="true" :IsFooter="false" :Size="'Lg'">
      <template v-if="IfModal" slot="header"></template>
      <template slot="body">
        <div class="contaainer p-2">
          <bnp-grid :Sortable="true" :key="TaskTableKey" :Selectable="false" :action="false" :propsRows="ListTasks" :propsColumn="TaskColumns" :hasRowNum="true">
            <template slot="isView" scope="props">
              <span :data-title="props.props.DateView" v-if="props.props.isView" class="fas fa-check-circle-o text-success Pointer"></span>
              <span v-else class="fas fa-times text-danger"></span>
            </template>
            <template slot="done" scope="props">
              <span :data-title="props.props.DateTimeDone" v-if="props.props.done" class="fas fa-check-circle-o text-success"></span>
              <span v-else class="fas fa-times text-danger"></span>
            </template>
          </bnp-grid>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '@/pages/Modal/Modal.vue'
export default {
  data() {
    return {
      IfModal: false,
      tablekey: 0,
      TaskTableKey: 0,
      ListTasks: [],
      TaskColumns: [
        { label: 'کاربر ', name: 'namFam', visibility: true },
        { label: 'موضوع اقدام', name: 'taskSubject', visibility: true },
        { label: 'مهلت انجام', name: 'doneDeadline', visibility: true },
        { label: 'مشاهده شده', name: 'isView', visibility: true },
        { label: 'انجام شده', name: 'done', visibility: true },
        { label: 'نام مشتری', name: 'customerName', visibility: true },
        { label: 'اولویت', name: 'tblComboIdGrp14Name', visibility: true },
      ],
      Results: [],
      Columns: [
        { label: 'شماره جلسه', name: 'sessionNumber', visibility: true },
        { label: 'موضوع', name: 'subject', visibility: true },
        { label: 'تاریخ جلسه', name: 'sessionDate', visibility: true },
        { label: 'زمان', name: 'time', visibility: true },
        { label: 'نوع جلسه', name: 'noeSession', visibility: true },
      ],
    }
  },
  components: { BnpGrid, Modal },
  props: ['Allsession'],
  created() {
    this.GetListSessions()
  },
  methods: {
    GetListSessions() {
      var DataAxios = { Action: 'ScrumSession?id=', Method: 'GET', ArryfildValue: null }
      if (this.Allsession) {
        DataAxios.Action += 'null'
      } else {
        DataAxios.Action += this.$session.get('UserInfo').tblUserId
      }
      this.$PostData(DataAxios).then((result) => {
        if ((result.status = 'success')) {
          this.Results = result.data
          this.tablekey++
        }
      })
    },
    CloseModal() {
      console.log('!!')
      this.IfModal = false
    },
    GetResults(scrumId) {
      console.log(scrumId)
      var DataAxios = { Action: 'ScrumSession/GetSessionTask', Method: 'POST', ArryfildValue: { tblScrumSessionID: scrumId, tblUSerId: null } }
      if (!this.Allsession) {
        DataAxios.ArryfildValue.tblUSerId = this.$session.get('UserInfo').tblUserId
      }
      console.log(DataAxios)

      this.$PostData(DataAxios).then((result) => {
        this.ListTasks = result.data
        this.IfModal = true
        TaskTableKey++
      })
    },
    DeleteQ(id) {
      this.$SweetQustion('هشدار', 'ایا از حذف جلسه اطمینان دارید؟', 'info', 'بله', 'انصراف', id, this.DeleteSession, this.cancel)
    },
    DeleteSession(id) {
      var DataAxios = { Action: 'ScrumSession/DeleteSession?id=' + id, Method: 'Delete', ArryfildValue: null }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefault('عملیات موفق', '', 'success', 2000)
          this.GetListSessions()
        } else {
          if ((result.status = 'fail')) {
            this.$mySweetDefault('هشدار', result.msg, 'warning', 2000)
          } else {
            this.$mySweetDefault('خطا در سرور', '', 'error', 2000)
          }
        }
      })
    },
    Edit(id) {
      var daxios = { Action: 'ScrumSession/GetForEdit?Id=' + id, Method: 'GET' }
      this.$PostData(daxios).then((result) => {
        this.$router.push({ name: 'NewSession', params: { EditResults: result.EditResults, EditScrum: result.EditScrum, Editusers: result.Editusers } })
      })
    },
  },
}
</script>
